import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import type { DropdownItem } from '@innogy/common-ui/forms';
import { postalAddressFormRenderingToContent } from '@innogy/common-ui/forms';
import type { TrackedToolComponent } from '@analytics/models';
import { TrackToolService } from '@analytics/events';
import { BaseEplusWizardComponent } from '@innogy/feh/shared';
import { Store } from '@ngrx/store';

import type { InsulationWizardToolTrackingSteps } from '../../store';
import {
  insulationWizardFormSubmitAction,
  parsedInsulationWizardToolTrackingConfig,
  selectInsulationWizardViewModel,
} from '../../store';
import type { InsulationWizardRendering } from '../../models/insulation-wizard-rendering.interface';
import { initializeInsulationFunnelComponent } from '../../utils/initialize-insulation-funnel-component';

@Component({
  selector: 'wl-insulation-wizard-container[rendering]',
  templateUrl: './insulation-wizard-container.component.html',
})
export class InsulationWizardContainerComponent
  extends BaseEplusWizardComponent<InsulationWizardRendering>
  implements OnInit, TrackedToolComponent<InsulationWizardToolTrackingSteps>
{
  viewModel$ = this.store$.select(selectInsulationWizardViewModel);

  get trackToolConfig() {
    const toolName = this.rendering.fields.componentName.value;
    return parsedInsulationWizardToolTrackingConfig(toolName);
  }

  buildingTypes: DropdownItem[] = [];

  constructor(
    protected readonly store$: Store,
    private readonly trackToolService: TrackToolService
  ) {
    super();
  }

  private getBuildingTypes(): DropdownItem[] {
    return this.rendering.fields.BuildingTypes.map((buildingTypeItem) => ({
      label: buildingTypeItem?.fields?.label?.value || '',
      value: buildingTypeItem?.fields?.value?.value || '',
    }));
  }

  ngOnInit() {
    this.buildingTypes = this.getBuildingTypes();

    this.store$.dispatch(
      initializeInsulationFunnelComponent(
        'wizard',
        this.rendering?.fields.FunnelSettings
      )
    );
  }

  submit(event: Event, formIsValid: boolean) {
    event.preventDefault();
    this.store$.dispatch(insulationWizardFormSubmitAction());

    if (formIsValid) {
      this.trackToolService.completeTool(this.trackToolConfig);
    }
  }

  get postalFormContent() {
    return postalAddressFormRenderingToContent(this.rendering);
  }
}
